export default __webpack_public_path__ + "static/media/icon-fiche-patient.9a1592ac.svg";